module.exports = __webpack_public_path__ + "static/media/huge_mobile_arrow.0853ef7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Users/images/huge_mobile_arrow.svg
// module id = 1495
// module chunks = 0